/** Textes de l'interface et faits sourcés. Tout en français. */

export const BANDEAU =
  "Outil citoyen indépendant · ni la Région Réunion, ni la CNDP · tracé d'étude extrait le 2 septembre 2026, susceptible d'évoluer · code source ouvert";

export const DEBAT = {
  titre: "Réunion Express — débat public CNDP",
  periode: "19 août → 26 novembre 2026",
  page: "https://www.debatpublic.fr/train-express-regional-de-la-reunion-reunion-express-974-8403",
  plateforme: "https://participer-debat-projet-train-reunion-express.cndp.fr/",
  dmo: "https://www.debatpublic.fr/sites/default/files/2026-06/R%C3%A9unionExpress_DMO_Web_PL.pdf",
};

/** Temps annoncés au dossier du maître d'ouvrage (DMO, juin 2026), entre repères. */
export const TEMPS_DMO_MIN: Record<string, number> = {
  "Saint-Benoît→Saint-Denis": 45,
  "Saint-Denis→Saint-Paul": 30,
  "Saint-Paul→Saint-Pierre": 45,
  "Saint-Pierre→Saint-Joseph": 15,
};

export const SOURCES = [
  {
    quoi: "Tracé et stations",
    source: "Visualisateur 3D officiel de la Région Réunion (Landweb3D), lié depuis le site du débat",
    date: "extrait le 2 septembre 2026",
  },
  {
    quoi: "Altimétrie",
    source: "IGN RGE ALTI via la Géoplateforme, profil rail contraint à 3,5 % de pente",
    date: "septembre 2026",
  },
  {
    quoi: "Fond de carte",
    source: "OpenStreetMap (ODbL) via Protomaps · relief Mapzen / AWS Terrain Tiles",
    date: "build du 31 août 2026",
  },
  {
    quoi: "Communes",
    source: "geo.api.gouv.fr (contours administratifs)",
    date: "septembre 2026",
  },
  {
    quoi: "Temps en voiture",
    source: "heure creuse : OSRM sur OpenStreetMap, sans trafic, entre centres-villes · heure de pointe : dossier du maître d'ouvrage p. 42-43 (« > 60 min »), ×1,5 sur Saint-Pierre → Saint-Joseph (hypothèse)",
    date: "3 septembre 2026",
  },
  {
    quoi: "Temps annoncés",
    source: "Dossier du maître d'ouvrage, CNDP, p. 22",
    date: "3 juin 2026",
  },
];
